import {
  
  Decoration,
  DecorationSet,
  EditorView,
  
  ViewPlugin,
  ViewUpdate,
  hoverTooltip,
} from "@codemirror/view";

export interface CodeCommentForEditor {
  line_number: number;
  code_comment: string;
}

/**
 * Extension that highlights lines by line number (1-based) with a CSS class.
 */
export function lineHighlightExtension(commentedLineNumbers: number[]) {
  return ViewPlugin.fromClass(
    class {
      decorations: DecorationSet;

      constructor(view: EditorView) {
        this.decorations = this.buildDecos(view, commentedLineNumbers);
      }

      update(update: ViewUpdate) {
        this.decorations = this.buildDecos(update.view, commentedLineNumbers);
      }

      buildDecos(view: EditorView, lineNumbers: number[]): DecorationSet {
        const decos: ReturnType<Decoration["range"]>[] = [];
        for (const lineNum of lineNumbers) {
          try {
            const line = view.state.doc.line(lineNum);
            decos.push(Decoration.line({ class: "cm-line-with-comment" }).range(line.from));
          } catch {
            // line number out of range
          }
        }
        return Decoration.set(decos);
      }
    },
    { decorations: (v) => v.decorations }
  );
}

/**
 * Extension that shows the code comment in a hover tooltip when hovering over a commented line.
 */
export function codeCommentHoverTooltipExtension(comments: CodeCommentForEditor[]) {
  const byLine = new Map<number, string>();
  comments.forEach((c) => byLine.set(c.line_number, c.code_comment));

  return hoverTooltip((view, pos) => {
    const line = view.state.doc.lineAt(pos);
    const text = byLine.get(line.number);
    if (text == null) return null;
    return {
      pos: line.from,
      end: line.to,
      above: true,
      create() {
        const dom = document.createElement("div");
        dom.className = "cm-code-comment-tooltip";
        dom.textContent = text;
        return { dom };
      },
    };
  });
}
